export const selectManufacturer = {
    bindings: {
        module: '@',
        identifier: '@',
        statePath: '@'
    },
    template: require('./select-manufacturer.html'),
    controller: 'SelectManufacturerController'
};
